import React from "react";
import { Spinner, Text, VStack } from "@chakra-ui/react";

const Loader = ({ size = "xl", text, ...rest }) => {
  return (
    <VStack
      spacing={4}
      direction="column"
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      <Spinner
        size={size}
        color="brand.primary.500"
        thickness="3px"
        speed="0.65s"
      />
      <Text>{text}</Text>
    </VStack>
  );
};

export default Loader;
